import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Badge from '@repo/ui/badge'
import { UserTwoIcon } from '@repo/ui/icons'

import { Paths } from '../../../lib/constants/path'
import { DispatchStaffInformation } from '../../../lib/types/models/trip-booking-dispatch-places/trip-booking-dispatch-place.properties'

type StaffBadgeProps = {
  staff: DispatchStaffInformation
  text?: string | ((staff: DispatchStaffInformation) => string)
  hasResponsibility?: boolean
}

export function StaffBadge({ staff, text, hasResponsibility = true }: StaffBadgeProps) {
  const { navigate } = useNavigator()
  // const hasResponsibility = (staff.user.tripBookings?.length ?? 0) > 0

  const badgeText = !text
    ? staff.lastName.toUpperCase()
    : typeof text === 'function'
      ? text(staff)
      : text

  return (
    <Badge.Link
      icon={
        hasResponsibility && (
          <UserTwoIcon className={'w-5 h-5'} color={tailwindColors.blue.DEFAULT} />
        )
      }
      variant={hasResponsibility ? 'blue' : 'white'}
      iconPosition={'start'}
      textColor={tailwindColors.blue.DEFAULT}
      text={badgeText}
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        if (staff.staffId)
          navigate(Paths.STAFF_UPDATE_PAGE.replace(':id', staff.staffId.toString()))
      }}
      style={{ border: 'none', textDecorationColor: tailwindColors.blue.DEFAULT }}
    />
  )
}
